import { render, staticRenderFns } from "./ShipmentList.vue?vue&type=template&id=3e434af6&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentList.vue?vue&type=style&index=0&id=3e434af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e434af6",
  null
  
)

export default component.exports